import React from "react";

import {Button, Flags} from "../common";

const defaultColor = '#6d6d6d'
const selectedColor = '#dbd56e'

const colorList = [
	'#8c1c13',
	'#52489c',
	'#2d93ad',
	'#034732',
	'#dbd56e'
]

export default class CreateDemocracy extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			playerFlag: 0,
			playerColor: '#000000',
			playerName: ''
		}
	}

	onClick = () => {
		this.props.updateData({ ...this.state })
		this.props.start()
	}

	render() {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center', overflowY: 'auto' }}>
				<div style={{ display: 'flex', flexDirection: 'column' }}>

					<div style={{ display: 'flex', flexDirection: 'column', paddingTop: 20, alignItems: 'center' }}>
						<div style={{ paddingBottom: 10, fontSize: 26 }}>Nation Name</div>
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
							<input onInput={(e) => { this.setState({ playerName: e.target.value }) }} />
						</div>
					</div>

					<div style={{ display: 'flex', flexDirection: 'column', paddingTop: 20 }}>
						<div style={{ paddingBottom: 10, paddingLeft: 10, fontSize: 26 }}>National Flag</div>
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
							<div onClick={() => { this.setState({ playerFlag: 0 }) }} style={{ cursor: 'pointer', padding: 10, borderStyle: 'solid', borderWidth: 2, borderColor: (this.state.playerFlag === 0) ? selectedColor : defaultColor, marginLeft: 10, marginRight: 10 }}>
								<Flags flag={0} color={this.state.playerColor} />
							</div>
							<div onClick={() => { this.setState({ playerFlag: 1 }) }} style={{ cursor: 'pointer', padding: 10, borderStyle: 'solid', borderWidth: 2, borderColor: (this.state.playerFlag === 1) ? selectedColor : defaultColor, marginLeft: 10, marginRight: 10 }}>
								<Flags flag={1} color={this.state.playerColor} />
							</div>
							<div onClick={() => { this.setState({ playerFlag: 2 }) }} style={{ cursor: 'pointer', padding: 10, borderStyle: 'solid', borderWidth: 2, borderColor: (this.state.playerFlag === 2) ? selectedColor : defaultColor, marginLeft: 10, marginRight: 10 }}>
								<Flags flag={2} color={this.state.playerColor} />
							</div>
							<div onClick={() => { this.setState({ playerFlag: 3 }) }} style={{ cursor: 'pointer', padding: 10, borderStyle: 'solid', borderWidth: 2, borderColor: (this.state.playerFlag === 3) ? selectedColor : defaultColor, marginLeft: 10, marginRight: 10 }}>
								<Flags flag={3} color={this.state.playerColor} />
							</div>
							<div onClick={() => { this.setState({ playerFlag: 4 }) }} style={{ cursor: 'pointer', padding: 10, borderStyle: 'solid', borderWidth: 2, borderColor: (this.state.playerFlag === 4) ? selectedColor : defaultColor, marginLeft: 10, marginRight: 10 }}>
								<Flags flag={4} color={this.state.playerColor} />
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', flexDirection: 'column', paddingTop: 20 }}>
						<div style={{ paddingBottom: 10, paddingLeft: 10, fontSize: 26 }}>Flag Colour</div>
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
							{
								colorList.map((value, key) => (
									<div onClick={() => { this.setState({ playerColor: value }) }} key={key} style={{ cursor: 'pointer', padding: 10, borderStyle: 'solid', borderWidth: 2, borderColor: (this.state.playerColor === value) ? selectedColor : defaultColor, marginLeft: 10, marginRight: 10 }}>
										<div style={{ backgroundColor: value, display: 'flex', flex: 1, width: 50, height: 50 }} />
									</div>
								))
							}
						</div>
					</div>

					<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 20, justifyContent: 'center' }}>
						{
							(!!this.state.playerName) ?
								<Button onClick={this.onClick} text={'Start'}/> : <div/>
						}
					</div>
				</div>
			</div>
		)
	}
}